import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import FinishedIcon from "assets/svg/finished.svg";
import Unit from "@/src/utils/constants/units";

import { numberFormatter } from "helpers/number-formatter";
import { resizeBalloonImage } from "helpers/map/commons";

import styles from "./styles.module.css";

const NewProjectBalloon = ({ listing }) => {
  const { name: title, images, companyName, area, flatCount, salesStatus, price, url, id } = listing || {};
  const { priceSummary, priceVisibility } = price || {};

  const salesCompletedClass = classNames({
    [styles.title]: true,
    [styles.salesCompleted]: true,
  });

  const priceFieldOptions = {
    salesCompleted: (
      <div className={salesCompletedClass}>
        <FinishedIcon />
        Satışı Tamamlandı
      </div>
    ),
    HIDDEN: <p className={styles.askPrice}>Fiyat Sor</p>,
    ASK: <p className={styles.askPrice}>Fiyat Sor</p>,
    STARTCOUNT: (
      <p className={styles.price}>
        {priceSummary?.toLocaleString("tr")}
        <span>‘den başlayan fiyatlarla</span>
      </p>
    ),
    RANGE: <p className={styles.price}>{priceSummary}</p>,
  };

  const getPriceField = () => {
    if (salesStatus !== "ONGOING") return priceFieldOptions.salesCompleted;
    const hasComponent = Object.keys(priceFieldOptions).includes(priceVisibility);
    if (!hasComponent) return null;
    return priceFieldOptions[priceVisibility];
  };

  const priceField = getPriceField();

  const updatedBalloonImageUrl = resizeBalloonImage(images?.[0]);
  return (
    <a id={`listingItem-${id}`} target="_blank" rel="noreferrer" href={url} className={styles.container}>
      <img src={updatedBalloonImageUrl} className={styles.image} />
      <div className={styles.rightPart}>
        <div className={styles.title}>{title}</div>
        <div className={styles.companyName}>{companyName}</div>
        <div className={styles.informationRow}>
          {area && (
            <span>
              {numberFormatter(area)} {Unit.M2.name}
            </span>
          )}
          {flatCount && <span>{flatCount} Konut</span>}
        </div>
        <div className={styles.projectPrice}>{priceField}</div>
      </div>
    </a>
  );
};

NewProjectBalloon.propTypes = {
  listing: PropTypes.object,
};

export default NewProjectBalloon;
